import _ from "lodash";
import { createSelector } from "reselect";
import EVENT_COLUMNS from "view/events/columns-info";
// The only things that depend on this selector will automatically
// query for events, so we consider the `initial` state to be a
// loading state as well.
export const selectEventsLoading = (s) => s.events.state === "loading" || s.events.state === "initial";
export const selectEventsError = (s) => s.events.state === "error" ? s.events.error : undefined;
export const selectEventsSort = (s) => s.events.state === "success" ? s.events.sort : undefined;
export const selectEventsLastUpdate = (s) => s.events.state === "success" ? s.events.lastUpdate : undefined;
export const selectEvents = (s) => s.events.state === "success" ? s.events.events : undefined;
export const selectSortedEvents = createSelector(selectEvents, selectEventsSort, (events, sort) => {
    if (sort && events) {
        const { direction, columnId } = sort;
        const columnInfo = _.find(EVENT_COLUMNS, (col) => col.id === columnId);
        if (!columnInfo) {
            throw new Error("Expected column to be defined.");
        }
        return _.orderBy(events, [columnInfo.getValue], direction);
    }
    else {
        return events;
    }
});
